import ZoomInOut from 'components/ZoomInOut/ZoomInOut';
import { environmentVars } from 'constants/services';
import React, { useState } from 'react';
import ReactMapGL, { Layer, LinearInterpolator } from 'react-map-gl';
import { SheetVersion } from 'records/SheetVersion';
import {
  defaultFlyAnimationDuration,
  maxZoomLevel,
  minZoomLevel,
} from '../constants';
import SheetImageSource from '../SheetImageSource';

type SheetScalerMapProps = {
  sheetVersion: SheetVersion;
};

const defaultViewport: Viewport = {
  latitude: 0,
  longitude: 0,
  zoom: 12,
  pitch: 0,
  bearing: 0,
};

const SheetScalerMap: React.FC<SheetScalerMapProps> = ({
  sheetVersion,
}: SheetScalerMapProps) => {
  const [viewport, setViewport] = useState<Viewport>(defaultViewport);

  const zoomMap = (zoomIn: boolean) => {
    const zoomIncrement = zoomIn ? 1 : -1;

    let newZoom = viewport.zoom + zoomIncrement;

    if (newZoom < minZoomLevel) {
      newZoom = minZoomLevel;
    }

    setViewport((prev) => ({
      ...prev,
      zoom: newZoom,
      transitionDuration: defaultFlyAnimationDuration,
      transitionInterpolator: new LinearInterpolator(),
    }));
  };

  return (
    <div
      id="scaler-map-container"
      style={{
        height: '100%',
        width: '100%',
      }}
    >
      <>
        <ReactMapGL
          {...viewport}
          height="100%"
          mapboxApiAccessToken={environmentVars.MAPBOX_API_KEY}
          maxPitch={60}
          maxZoom={maxZoomLevel}
          minZoom={minZoomLevel}
          attributionControl={false}
          onViewportChange={setViewport}
          width="100%"
        >
          <Layer type="background" paint={{ 'background-color': '#c3c5c9' }} />
          <SheetImageSource
            mapContainerId="scaler-map-container"
            sheetVersion={sheetVersion}
            onFitImageViewportCalculated={(fitImageViewport) =>
              setViewport(fitImageViewport)
            }
          />
        </ReactMapGL>
        <ZoomInOut
          id="map-prepare-scale"
          disableZoomIn={viewport.zoom === maxZoomLevel}
          disableZoomOut={viewport.zoom <= minZoomLevel}
          handleZoomIn={() => zoomMap(true)}
          handleZoomOut={() => zoomMap(false)}
        />
      </>
    </div>
  );
};

export default SheetScalerMap;
